module.exports = __webpack_public_path__ + "img/pl5daily_bg.6f8ab051.png";